export default {
	app: {
		name: 'GW Reader  Writing Center',
		Chinese: '中文',
		English: 'English',
		codeemail: '验证码',
		coderesend: '秒后重发',
		resend: '重新发送'
	},
	menu: {
		personal_center: '首页',
		author1:'普通作者',
		my_information: '我的信息',
		my_record: '作家中心',
		Works_management: '作品管理',
		author_management:'作者管理',
		works_reviewer: '审核管理',
		My_creation: '我的作品',
		new_work: '新建作品',
		edit_work: '编辑作品',
		interactive_space: '互动空间',
		data_center: '数据中心',
		number_readings: '阅读数',
		Article_unlock: '文章解锁',
		Likes: '点赞数',
		Favorites: '收藏数',
		my_income: '我的收入',
		Work_income: '作品收入',
		Translation_income: '翻译收入',
		morebook:"",
		setting: '设置',
		FAQs_and_Help: '常见问题解答和帮助',
		loginOut: '退出',
		messages: '消息',
		my_information: '我的信息',
		notice: '通知',
		Income_breakdown: '收入明细',
		Copyright_income: '版权收入',
		Reward_details: '打赏明细',
		total_revenue: '稿酬总收入',
		Incentive_money: '奖励金',
		Comment_details: '评论详情',
		Comment_management: '评论管理',
		New_setting: '新建设定',
		Sign_management: '签署管理',
		to_write: '去写作',
		my_assets: '我的资产',
		Profile_and_Account: '资料与账户',
		reviewerWork: '作品集合',
		Apply_withdrawal:"申请提现",
	},
	interact: {
		confirm: '确定',
		cancel: '取消',
		hint: '提示'
	},
	page: {
		back: '返回',
		Please_enter_content: '请输入内容',
		view_all: '查看全部',
		empty: '清空',
		tabs: {
			all: '全部',
			end: '完结',
			serialize: '连载'
		}
	},
	login: {
		username: '用户名',
		password: '密码',
		email: '邮箱',
		your_email: '你的邮箱',
		verification_code: '验证码',
		phone_email_error: '手机号码/邮箱错误',
		password_error: '密码错误',
		switch_verification_code: '点击切换验证码',
		verification_code_error: '验证码错误',
		forgot_password: '忘记密码',
		loginin: '登入',
		register: '注册',
		login_sms_code: '短信验证码登录',
		phone: '手机号码',
		enter_phone_number: '输入手机号',
		account_password_login: '账号密码登录',
		get_verification_code: '获取验证码',
		password_confirmation: '确认密码',
		email_verification_code: '邮箱验证码',
		already_member: '已有账号',
		User_Services_Agreement: '用户服务协议',
		Privacy_Policy: '隐私政策',
		isLogout: '确定退出登录吗?',
		notmatch:'请确认密码'
	},
	address: {
		cn: '中国',
		us: '美国',
		nanjing: '南京',
		chengdu: '成都',
		shenzhen: '深圳',
		guangzhou: '广州'
	},
	personal: {
		myrecord: '我的记录'
	},
	resetpwd: {
		resetpwd: '重置密码',
		account: '账号信息',
		verify: '验证身份',
		compelete: '完成',
		number: '手机号码/邮箱',
		enternumber: '请输入要找回的邮箱',
		shiftnumber: '点击切换验证码',
		wrongnumber: '验证码错误',
		next: '下一步',
		preview: '上一步',
		back: '返回',
		notmatch: '两次密码不一致',
		pwdrule: '密码6-20位，必须以字母开头，可带数字符号',
		resuccess: '密码重置成功',
		back2login: '返回登录页面',
		background2login: '后系统自动返回登录页面',
		verifycode: '验证码',
		codesended: '验证码已发送至',
		emailcode: '邮箱验证码',
		codeerror: '验证码错误',
		resendinsecond: '秒后重发',
		resend: '重新发送',
		reget: '重新获取',
		password: '密码',
		passwordcomfirm: '确认密码',
		sended: '已发送,请注意查收！'
	},
	myrecord: {
		all: '全部',
		thisweek: '本星期',
		thismonth: '这个月',
		lastest: '最近三个月',
		time: '时间',
		address: '地址位置',
		loginstatus: '登录状态',
		default: '默认'
	},
	myInfomation: { //我的信息:/writer/#/user/information
		writerId: '作者id',
		works: '作品',
		integral: '积分',
		penName: '笔名',
		realName: '真实姓名',
		phone: '手机号码',
		collection: '收藏',
		Email: '电子邮箱',
		udpateInfo: '更改个人资料',
		cancel: '取消',
		updateSucess: '更新成功',
		updateFail: '更新失败',
		editeHeadPath: '编辑头像',
		pleaseInputYourPenName: "请输入你的笔名",
		pleaseInputPhone: '请输入您的手机号',
		emailFormat: '邮箱格式不正确',
		cancel: "取消",
		commit: "提交"
	},
	likes:{
		keys:'请输入关键词',
		inquire:'查询',
		require:'重新统计',
		all:'全部',
		time:'按时间',
		composition:'作品A-Z',
		down:'合计降序',
		up:'合计升序',
		composition1:'作品',
		chater:'章节',
		title:'标题',
		content:'内容提要',
		likes:'点赞数',
		updateTime:'更新时间',
		num:'$3434'
	},
	privacyPolicy:{
		privacy:'隐私政策'
	},
	newWork:{
		Click_upload:'点击上传',
		only_upload:'只能上传jpg/png文件，且不超过100kb',
		composition_name:'作品名称',
		composition_name1:'请输入作品名称,填写时不需要书名号',
		author:'作者',
		pen_name:'请输入你的笔名',
		translator:'译者',
		selection:'可选',
		work_type:'作品类型',
		choose:'请选择',
		writing_type:'篇幅类型',
		sourceLanguage:'源语言国家编号',
		objective_reader:'目标读者',
		work_introduce:'作品介绍',
		brief_introduction:'请输入作品简介',
		establish_work:'创建作品',
		save:'保存',
		cancel:'取消',
		aa:'Leading Gender'
	},
	setup:{
		classify:'设定分类',
		choose:'请选择',
		delete_type:'删除分类',
		edit_type:'编辑分类',
		new_setting:'新建设定',
		delete:'删除',
		edit:'编辑',
		classifyName:'分类名称',
		classifyName1:'请填写分类名称',
		cancel:'取 消',
		sure:'确 定',
		title:'设定标题',
		inputTitle:'请输入标题',
		content:'设定内容',
		content1:'请输入内容'		
	},
	signingManagement:{
		submit:'Submit',
		content1:'content1',
		ContractS:'Contract type selections',
		titles:'BookName',
		choose:'请选择',
		waiteAudit:'待审核',
		pass:'审核通过',
		noPass:'审核不通过',
		date:'请选择日期时间',
		content1:'请输入内容',
		chooseDate:'请选择日期',
		save:'保存',
		reset:'重置',
		return:'返回',
		BookIdea:'Book Idea',
		BookInformation:'Book Information',
		Description:'Description(introduce your book to reader)',
		Title:'Title:',
		BookID:'Book ID:',
		AutgorsPenName:'Autgors Pen Name',
		DailyUpdated:'Daily Updated',
		Status:'Status',
		PeriodEra:'Period/Era',
		WordsReleased:'Words Released',
		TotalWords:'Total Words',
		Gener:'Gener',
		// reviewState:'reviewState',
		pass:'通过',
		shenhe:'审核',
		BookRating:'Book Rating',
		StoryBackground:'Story Background',
		Period:'Period',
		Language:'Language',
		Writingtype:'Writing type',
		objective_reader:'Leading Gender',
		Tags:'Tags',
		configurationManagement:'配置管理',
		roleManagement:'角色管理',
		TimedTaskCompensation:'定时任务补偿',
		SelectTags:'Select tags',
		description:'description',
		DDD:'descriptiondescriptiondescriptiondescriptiondescriptiondescriptiondescriptiondescription',
		ApplicationInformation:'Application Information',
		ApplyTime:'Apply Time',
		change_photo:'修改封面',
		Theme:'Theme',
		TheSetting:'Characters` Setting',
		TheMainCharacters:"The main character's appearance/occupation/age/status",
		ThePlot:'The Plot',
		wmt:'What Make The Story Special and Attractive',
		tenow:'Total Estimated Number of Words',
		wpeoa:'Words Per Episode On Average',
		PersonalIntroduction:'Personal Introduction',
		Email:'Email',
		Birthday:'Birthday',
		Link:"Personal Facebook / instagram / Twitter / WhatsApp Link （Anyone is acceptable）",
		ChapterDescrition:'Simple description about the first 6 chapters for the start/middle/end: (it will help the writer to structure the story clearly)',
		chapterStart:'The Start Of Chapter',
		chapterMiddle:'The Middle Of Chapter',
		chapterEnd:'The End Of Chapter',
		chapterContent:'Chapters',
		Opinions:'Editor review',
		PrimaryEditor:'Primary Editor',
		identitles:'identitles',
		PlotFramework:'Plot and story skeleton',
		CharactersIntroduction:"Characters' Setting",
		points:'points',
		Evaluation:'Evaluation on Writing Style',
		WorkHighights:"Work's Highights",
		WorkShortcomings:"Work's Shortcomings",
		WorkSource:'Work Source',
		URL:'URL of the1213123 ',
		reviewState:'reviewState',
		content01:"Tip: including their ages, occupations, roles, and relations with each other ",
		content02:'请输入章节内容',
		content2:'dcwcfwqeffewrgwtgreabzd请问干热风恢复规划GV委屈额风趣而v无法号去ever给他红包都被不在\n\tqwed',
		
	},
	writing:{
		chater:'Add chapters',
		draft:'草稿箱',
		issue:'已发布',
		recycle:'回收站',
		return:'返回',
		carrier:'单章上传txt',
		batch:'批量上传rar',
		subsection:'在线分卷新增',
		classification:'分卷名',
		classification1:'请输入分卷名',
		classificationInfo:'分卷简介',
		inputClassification:'请输入分卷简介',
		No1:'第1章',
		save:'保存',
		cancel:'取消',
		title:'章节标题',
		content:'内容摘要',
		title1:'第1章 飞龙在天',
		formalContent:'正文内容',
		chaterContent:'本章内容(限3万字以内)',
		saveDraft:'存入草稿',
		preview:'预览查看',
		sent:'定时发布',
		nowsent:'立刻发布',
		num:'字数：',
		task:'定时任务',
		time:'执行时间',
		date:'选择日期时间',
		sure:'确 定',
		look:'预览',
		close:'关 闭'
	},
	loginRecord:{
		all:'全部',
		complete:'完结',
		series:'连载'
	},
	message:{
		clear:'清空',
		messages:'全部消息',
		talk:'评论',
		privacy:'私信'
	},
	notice:{
		allNotice:'全部通知',
		collect:'收藏',
		third:'点赞',
		four:'公告',
		system:'系统'
	},
	personalCenter:{
		time:'时间',
		ip:'IP',
		location:'地址位置',
		login:'登录状态',
		momo:'默认IP',
		seemore:'查看更多'
	},
	commentDetial:{
		bookName:'书名fafa',
		comtent:'章节内容',
		like:'点赞',
		total:'共200赞',
		talk:'评论',
		talk1:'共200条评论',
		ff:'茄叵工',
		jiaj:'加精',
		time1:'2020-10-1',
		ll:'会拍马屁的妖精',
		hf:'120回复',
		like1:'10赞',
		other:'其他书评',
		num1:'100',
		num2:'200',
		name2:'书名',
		time3:'2021/03/03',
		detail:'查看详情'	
	},
	commentManage:{
		keys:'请输入关键字',
		look:'查询',
		forbid1:'禁言7天',
		forbid2:'永久禁言',
		delete:'删除',
		zuop:'作品',
		time:'按时间',
		type:'类型',
		property:'属性',
		commentT:'评论时间',
		reply:'最新回复',
		aaaa:'作品A-Z',
		down:'合计降序',
		up:'合计升序',
		zzz:'评论作品',
		comment1:'评论人',
		nickName:'nickName',
		likep:'点赞人',
		likess:'点赞数',
		replyss:'回复数',
		replyp:'回复人',
		likeTime:'点赞时间',
		Time1:'06/10 12:22',
		Time:'06/10 12:22',
		replyTime:'回复时间',
		Comment1:'评论属性',
		top:'置顶',
		title2:'禁言7天',
		sure7:'确认已选中评论人禁言7天？',
		sure11:'禁言对象将在7天内无法评论您的作品',
		sure:'确 定',
		cancel:'取 消',
		delete1:'删除评论',
		delete2:'确认删除已选中评论？',
		delete3:'删除后将无法恢复',	
	},
	interactiveSpace:{
		comment:'评论',
		num:'5000',
		choice:'请选择',
		mionth1:'近1个月',
		mionth2:'近6个月',
		year1:'近1年',
		year2:'近2年',
		review:'评论管理',
		seemore:'查看更多',
		WorksComments:'评论作品',
		type:'类型',
		commentator:'评论人',
		nickName:'nickName',
		dateline:'评论时间',
		TIME:'06/10 12:22',
		Thumb:'点赞人',
		likenum:'点赞数',
		replies:'回复数',
		ThumbTime:'点赞时间',
		replier:'回复人',
		recoveryTime:'回复时间',
		CommentProperties:'评论属性',
		top:'置顶',
		MyBookReview:'我的书评',
		review1:'写书评',
		num3:'100',
		num2:'200',
		bookName:'书名',
		time4:'2021/03/03',
		viewDetails:'查看详情'
	},
	releaseComment:{
		CommentsManage:'评论管理',
		work:'作品',
		inputName:'请输入作品名称',
		title:'标题',
		inputTitle:'请输入标题',
		mainBody:'正文',
		InputmainBody:'请输入正文内容',
		issue:'发布',
		cancel:'取消'
	},
	translation:{
		sort:'排序',
		boom:'畅销',
		new:'最新',
		bookName:'书名',
		time4:'2021/03/03',
		money:'$330',
		history:'history',
		inpKeys:'请输入关键字',
		inquire:'查询',
		antime:'按时间',
		finish:'按完成度',
		moneyDown:'金额降序',
		moneyUp:'金额升序',
		all: '全部',
		end: '完结',
		serialize: '连载',
		works:'作品',
		newtime:'更新时间',
		time5:'2021/10/02',
		finish1:'完成度',
		progress:'进度',
		sum:'金额',
		num34:'$3434',
		type1:'类型'
	},
	workIncome:{
	    choice:'请选择',
		mionth1:'近1个月',
		mionth2:'近6个月',
		year1:'近1年',
		year2:'近2年',
		detailIncome:'收入明细',
		inputc:'请输入内容',
		inquire:'查询',
		sort:'排序',
		all: '全部',
		end: '完结',
		serialize: '连载',
		works:'作品',
		GrossRemuneration:'稿酬总收入',
		Exceptionalincome:'打赏收入',
		bounty:'奖励金',
		Royalties:'版权收入',
		progress:'进度',
		Update:'更新时间',
		viewDetails:'查看详细',
		startdate:'开始日期',
		endate:'结束日期',
		to:'至'
	},
	author_remuneration:{
		keys:'请输入关键字',
		inquire:'查询',
		year:'选择年',
		all: '全部',
		week:'一周内',
		month:'一月内',
		years:'一年内',
		year1:'年',
		month1:'月',
		week1:'周',
		day1:'日',
		works: '作品',
		m1:'1月',
		m2:'2月',
		m3:'3月',
		m4:'4月',
		m5:'5月',
		m6:'6月',
		m7:'7月',
		m8:'8月',
		m9:'9月',
		m10:'10月',
		m11:'11月',
		m12:'12月',
		num34:'$3434',
	},
	bonus:{
		keys:'请输入关键字',
		inquire:'查询',
		all: '全部',
		antime:'按时间',
		composition:'作品A-Z',
		down:'合计降序',
		up:'合计升序',
		composition1:'作品',
		time:'时间',
		CreateIncentives:'创作激励',
		PropertyIncome:'道具收入',
		CreationSubsidies:'创作补贴',
		MonthlyReward:'月票奖励',
		EssayReward:'征文奖励',
		else:'其他',
		summation:'合计',
		num34:'$3434',
	},
	receiptDetails:{
		detective:'神探',
		adfkjwkf:'adfkjwkf',
		pageview:'阅读数',
		likenum:'点赞数',
		private:'收藏数',
		Unlock:'解锁文章',
		coin :'书币',
		num1:'12313',
		num2:'1213',
		num3:'3423',
		num4:'4232',
		num5:'232',
		GrossRemuneration:'稿酬总收入',
		Exceptionalincome:'打赏收入',
		bounty:'奖励金',
		Royalties:'版权收入',
		TranslationincomeL:'翻译收入',
		chapter:'章节',
		title:'标题',
		Gross:'稿酬',
		ExceptionalNumber:'打赏数',
		money:'$30.00',
		money1:'$3434',
		remark:'备注'
	},
	copyright:{
		keys:'请输入关键字',
		inquire:'查询',
		sign:'签约类型',
		num1:'1111',
		num2:'2222',
		num3:'3333',
		num4:'4444',
		typeWorks:'作品类型',
		ZM1:'ffff',
		ZM2:'qqqq',
		ZM3:'cccc',
		ZM4:'aaaa',
		all: '全部',
		timeContract:'签约时间',
		antime:'按时间',
		composition:'作品A-Z',
		down:'合计降序',
		up:'合计升序',
		numericalOrder:'序号',
		works:'作品',
		money1:'$3434',
		CopyrightBuyer:'版权买方',
		CopyrightAmount:'版权金额',
		timeContract:'签约时间',
		history:'history'
	},
	reward:{
		keys:'请输入关键字',
		inquire:'查询',
		all: '全部',
		antime:'按时间',
		composition:'作品A-Z',
		down:'合计降序',
		up:'合计升序',
		numericalOrder:'序号',
		Exceptional :'打赏人',
		name:'name',
		ExceptionalTime:'打赏时间',
		ExceptionalWork:'打赏作品',
		ExceptionalNumber:'打赏数',
		num1:'$30',
		remark:'备注',
		num34:'$3434',	
	},
	articleUnlock:{
		keys:'请输入关键字',
		inquire:'查询',
		rangeSeparator:'至',
		startPlaceholder:'开始日期',
		endPlaceholder:'结束日期',
		works:'作品',
		chapter:'章节',
		title:'标题',
		synopsis:'内容提要',
		UnlockDBF:'解锁数',
		UnlockBOOK:'解锁书币',
		Update:'更新时间',
		Collect:'收藏数',
		read:'阅读数'
	},
	userAgreent:{
		a1:'用户服务协议'
	},
	workList:{
		introduction:'简介：',
		Collect:'收藏：',
		Edit:'编辑',
		ConceptualWork:'作品设定',
		SignApplication:'签署申请',
		SignProcess: '签约进度',
		published:'已发布',
		publish:'发布',
		writing:'去写作',
		choose:'请选择',
		NewSettingCategory:'新建设定分类',
		characterDesign:'人物设定',
		set:'背景设定',
		otherSet:'其他设定',
		DeleteCategory:'删除分类',
		EditCategory:'编辑分类',
		newSet:'新建设定',
		Delete:'删除',
    draft1:'草稿箱章节列表',
    zp:'作品',
    chater:'章节',
    title:'标题',
    synopsis:'内容摘要',
    classification:'分卷信息',
    num:'数字',
    time1:'定时发布',
    time2:'定时发布时间',
    yes:'是',
    no:'否',
    operate:'操作',
    Published:'已发布',
    Modificate:'修改',
    restore:'还原',
    cancel:'彻底删除',
    Publish1:'批量发布',
    Publish2:'批量定时发布',
    Publish3:'批量删除',
    Publish4:'批量还原草稿',
    Publish5:'批量彻底删除',
	},
	error:{
		error1:'抱歉，页面找不到了',
		return:'返回首页'
	}
}